import Image from 'next/legacy/image'
import ImageMasthead from 'components/image-masthead'
import { Button, Text } from 'components/atomic'
import { patchNotesUrlSS6 } from 'lib/constants'

const LiveStreamVideoId = 'yE3T617pzYY'

const SixthSnapshotRevealPage = () => {
  return (
    <>
      <ImageMasthead image="/images/live-stream/masthead.jpg" className="sm:!min-h-[540px] 3xl:!min-h-[40rem]">
        <div className="mx-auto max-w-[1440px] px-0 pt-32 sm:px-10 md:pt-36 xl:pt-44">
          <Text variant="h2" tag="h2" className="mb-1 text-center">
            VARIANT INTELLIGENCE
          </Text>
          <div className="mb-14 text-center text-xl font-bold uppercase tracking-wide text-[#56C7D8] lg:text-[30px] lg:leading-[39px]">
            DEADROP Snapshot VI Reveal
          </div>
          <div>
            <div className="mb-2 flex items-center">
              <div className="relative mr-1 h-7 w-7 min-w-[28px]">
                <Image src="/images/deadrop/DEADROP 1.png" layout="fill" objectFit="cover" alt="Deadrop" />
              </div>
              <Text variant="subtitle2" tag="p">
                LIVESTREAM - Tuesday, July 11 - 3pm PST
              </Text>
            </div>
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-3/4">
                <div className="aspect-video">
                  <iframe
                    src={`https://www.youtube.com/embed/${LiveStreamVideoId}`}
                    title="6rd Snapshot Reveal"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="h-full w-full"
                  ></iframe>
                </div>
              </div>
              <div className="lg:w-1/4">
                <div className="h-64 md:h-80 lg:h-full">
                  <iframe
                    src={`https://www.youtube.com/live_chat?v=${LiveStreamVideoId}&embed_domain=${window.location.hostname}`}
                    className="h-full w-full"
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="mt-10 flex flex-col justify-evenly md:flex-row">
              <Button href="https://discord.gg/midnight-society" target="_blank" className="mb-4 md:!w-60">
                <span>Join The Discord</span>
              </Button>
              <Button href={patchNotesUrlSS6} target="_blank" className="mb-4 md:!w-60">
                <span>Snapshot VI Patch Notes</span>
              </Button>
              <Button href="/creative" target="_blank" className="mb-4 md:!w-60">
                <span>Learn More About UGC</span>
              </Button>
            </div>
          </div>
        </div>
      </ImageMasthead>
    </>
  )
}

export default SixthSnapshotRevealPage
